/**
 * The tenant's logo in the operator header (ADR-0036 Fase 2). Fetched from the
 * authentication-only `/settings/tenant-brand` (every operator sees it). The logo
 * is a `data:` URL so a plain `<img>` works. Renders nothing when no logo is set.
 */
import { useQuery } from "@tanstack/react-query";

import { cn } from "@/lib/cn";
import { tenantProfileApi } from "@/lib/tenantProfile";

/** The tenant logo image. `className` overrides the default header styling so
 *  the SAME source can render in the account dropdown (ADR-0036 Fase 2 moved it
 *  off the header action rail — it competed with the controls). */
export function TenantBrandLogo({ className }: { className?: string }) {
  const { data } = useQuery({
    queryKey: ["tenant-brand"],
    queryFn: () => tenantProfileApi.getBrand(),
    staleTime: 5 * 60 * 1000,
  });
  if (!data?.logo_url) return null;
  return (
    <img
      src={data.logo_url}
      alt={data.name ?? "logo"}
      title={data.name ?? undefined}
      className={cn("h-7 max-w-[7rem] object-contain", className)}
    />
  );
}
